import FileUploadButton from './FileUploadButton';

export default FileUploadButton;
